import React, { useContext } from 'react'
import { IconDeviceDesktop, IconDeviceMobile } from '@tabler/icons-react'
import { ThemeContext } from 'theme/ThemeProvider'
import styled from 'styled-components'
import { useThemeStore } from 'app/hooks'

const MobileToggle = () => {
	const { isMobile, toggleMobile, theme } = useContext(ThemeContext)
	const { data: themeStore, mutate: mutateThemeStore } = useThemeStore()

	if (themeStore?.isMobile === undefined) {
		mutateThemeStore({
			isMobile: false,
		})
	}

	const icon = isMobile ? (
		<IconDeviceMobile size={18} />
	) : (
		<IconDeviceDesktop size={18} />
	)

	return (
		<ToggleButton
			isMobile={isMobile || false}
			pointColor={theme?.COLORS?.point}
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
				toggleMobile()
				mutateThemeStore({
					...themeStore,
					isMobile: isMobile ? false : true,
				})
			}}>
			{icon}
		</ToggleButton>
	)
}

const ToggleButton = styled.button<{ isMobile?: boolean; pointColor?: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 8px;
	border: none;
	background: transparent;
	color: ${props => props.theme.COLORS.textw};
	cursor: pointer;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	position: relative;

	&:hover {
		background: ${props => props.pointColor ? props.pointColor + '20' : 'rgba(0, 0, 0, 0.1)'};
		color: ${props => props.pointColor || props.theme.COLORS.point};
		transform: translateY(-1px);
	}

	&:active {
		transform: scale(0.95);
	}

	svg {
		transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
	}

	&:hover svg {
		transform: scale(1.1);
	}

	@media (max-width: 1200px) {
		width: 28px;
		height: 28px;

		svg {
			width: 16px;
			height: 16px;
		}
	}

	@media (max-width: 900px) {
		width: 26px;
		height: 26px;

		svg {
			width: 15px;
			height: 15px;
		}
	}
`

export default MobileToggle
